import { useEffect, useRef, useState } from "react";
import {
  StaffListConstants,
} from "../../constants/constants";
import PersonalInformationDynamic from "./PersonalInformationDynamic";
import { add, set } from "date-fns";
import EditIconForEditFLow from "../../assets/images/EditIconForEditFLow";
const tableHeaderStyle = "text-black staffListHeader font-nunito";
const tableDataStyle = "text-center quickLinksDescription text-black";
const WorkExperienceTable = ({
  userDetail,
  handleEditWorkInformation,
  editModeForWorkDetails,
  workDetailsIndex,
  order,
  addMoreWorkInfo,
  setEditPayloadjson,
  jsonForEditData,
  isEditMode = false,
  showWorkTableInEditFlow,
  errors,
  setIsSaveButtonClicked,
  isSaveButtonCLicked,
  setErrors,
  workDetailsIndexRef,
  addMoreWorkEditRef,
  setIsWorkEditButtonClicked,
  setIndexOfWorkDetails,
  setShowFeildsToEditInOnboardingFlow,
  setIsEducationalEditButtonClicked,
  isPreviousButtonClicked,
  indexOfWorkDetails,
  setIsWorkDetailsNull,
  isWorkDetailsNull,
  subSegmentRef,
  setAttributesArray,
  setIsWorkEditButtonClickedWithoutPreviousButton,
  isWorkEditButtonClickedWithoutPreviousButton,
}: {
  userDetail: any;
  handleEditWorkInformation: any;
  editModeForWorkDetails: any;
  workDetailsIndex: any;
  order: any;
  addMoreWorkInfo: any;
  setEditPayloadjson: any;
  jsonForEditData: any;
  isEditMode?: any;
  showWorkTableInEditFlow?: any;
  errors?: any;
  setIsSaveButtonClicked?:any;
  isSaveButtonCLicked?:any;
  setErrors?:any;
  workDetailsIndexRef?: any;
  addMoreWorkEditRef?: any;
  setIsWorkEditButtonClicked?: any;
  setIndexOfWorkDetails?: any;
  setShowFeildsToEditInOnboardingFlow?: any;
  setIsEducationalEditButtonClicked?: any;
  isPreviousButtonClicked?: any;
  indexOfWorkDetails?: any;
  isWorkDetailsNull?: any;
  setIsWorkDetailsNull?: any;
  subSegmentRef?: any;
  setAttributesArray?: any;
  setIsWorkEditButtonClickedWithoutPreviousButton?: any;
  isWorkEditButtonClickedWithoutPreviousButton?: any;
}) => {
  let workInfo: any[] = [];
  if (isEditMode) {
    workInfo = userDetail[order]?.subSegments?.filter(
      (item: { name: string }) => item.name === "Work Experience"
    );
  } else {
    workInfo = userDetail;
  }
  const [activeWorkIndex, setActiveWorkIndex] = useState(workDetailsIndexRef);

  useEffect(() => {
    if( !addMoreWorkEditRef) {
    if (activeWorkIndex) {
      const newJson = workdetailforedit();
      setJsonForEdit(newJson);
      setTempFlag(false);
    }
  }
  }, [addMoreWorkInfo, userDetail, jsonForEditData, activeWorkIndex]);



// Sync the ref and state — whenever ref changes, update state
useEffect(() => {
  setActiveWorkIndex(workDetailsIndexRef);
}, [workDetailsIndexRef]);
  const workdetailforedit = () => {
    return {
      segmentId: userDetail[order]?.segmentId,
      name: userDetail[order]?.name,
      description: userDetail[order]?.description,
      segmentOrder: userDetail[order]?.segmentOrder,
      subSegments: [
        addMoreWorkInfo ? addMoreWorkInfoForEdit() : workInfo[activeWorkIndex],
      ],
    };
  };
  const addMoreWorkInfoForEdit = () => {
    if (jsonForEditData) {
      const firstWorkInfo = addMoreWorkInfo
        ? jsonForEditData?.formSegments[order]?.subSegments.find(
            (subSegment: any) => subSegment.name === "Work Experience"
          )
        : userDetail[order]?.subSegments.find(
            (subSegment: any) => subSegment.name === "Work Experience"
          );
      const clearedEducationalInfo = JSON.parse(JSON.stringify(firstWorkInfo));
      clearedEducationalInfo?.attributes?.forEach((attr: any) => {
        attr.value = ""; // Resetting values to empty
      });
      return clearedEducationalInfo;
    }
  };

  const removeEmptyWorkInfo = (formSegment: any) => {
    // Get all Educational Information subSegments
    const educationalInfos = formSegment?.subSegments?.filter(
      (sub: any) => sub.name === "Work Experience"
    );
  
    // Get the LAST "Educational Information"
    const lastEducationalInfo = educationalInfos[educationalInfos.length - 1];
  
    // Check if all attributes are empty
    const areAllAttributesEmpty = (subSegment: any): boolean => {
      return subSegment?.attributes?.every(
        (attr: any) =>
          attr.value === "" || attr.value === null || attr.value === undefined
      );
    };
  
    console.log("Is last Educational Info empty?", areAllAttributesEmpty(lastEducationalInfo));
  
    return areAllAttributesEmpty(lastEducationalInfo);
  };
  useEffect(() => {
    if (addMoreWorkInfo) {
      if(!removeEmptyWorkInfo(jsonForEditData?.formSegments[order])){
        jsonForEditData?.formSegments[order]?.subSegments.push(
          addMoreWorkInfoForEdit()
             );
             }
    }
  }, [addMoreWorkInfo]);
  useEffect(() => {
    setJsonForEdit(workdetailforedit());
  }, []);
  const [jsonForEdit, setJsonForEdit] = useState<any>();
  const [tempFlag, setTempFlag] = useState<boolean>(true);
  useEffect(() => {
    if ((addMoreWorkInfo && tempFlag) || showWorkTableInEditFlow) {
      setJsonForEdit(workdetailforedit());
      setTempFlag(false);
    }
  }, [addMoreWorkInfo, userDetail, jsonForEditData]);



  const handleEditWorkInformationInOnboardingFlow = (index:any) => {
    if(!isPreviousButtonClicked){
      setIsWorkEditButtonClickedWithoutPreviousButton(true);
    }
    setAttributesArray(subSegmentRef[index].attributes);
setIsWorkEditButtonClicked(true);
setIndexOfWorkDetails(index);
setShowFeildsToEditInOnboardingFlow(true);
setIsEducationalEditButtonClicked(false);
  }

  const allWorkDetailsAreNull = workInfo.every((item: any) => {
    if (item?.name !== "Work Experience") return false;
    const attributes = item?.attributes?.reduce((acc: any, attr: any) => {
      acc[attr.name] = attr?.value;
      return acc;
    }, {});
    return Object.values(attributes).every(value => value === null);
  });
  // const [isWorkDetailsPresent,setIsWorkDetailspresent] = useState(false);
  // Optional: update state once outside render cycle
  useEffect(() => {
    if (typeof setIsWorkDetailsNull === "function") {
      console.log("allWorkDetailsAreNullInside Useeffevct", allWorkDetailsAreNull);
      setIsWorkDetailsNull(allWorkDetailsAreNull);
    }
  }, []); 
   return (
    <>
      <div className="block lg:hidden">
        <div>
          {editModeForWorkDetails ? (
            <div>
              <PersonalInformationDynamic
                jsonObjForEdit={
                  addMoreWorkInfo ? jsonForEditData : [userDetail]
                }
                jsonobj={[jsonForEdit]} // Wrap the returned object in an array
                order={0}
                isEditMode={true}
                indexOfValueToBeModified={workDetailsIndex}
                setEditPayloadjson={setEditPayloadjson}
                addMoreWorkInfo={addMoreWorkInfo}
                // addmoreEducationOrder={order}
                addmoreWorkOrder={order}
                setJsonForEditFlow={setJsonForEdit}
                showWorkTableInEditFlow={showWorkTableInEditFlow}
                isSaveButtonCLicked={isSaveButtonCLicked}
                setIsSaveButtonClicked={setIsSaveButtonClicked}
                errors={errors}
                setErrors={setErrors}
                isWorkDetailsNullRef={isWorkDetailsNull}
                // setEditPayloadjson={setEditPayloadjson}
              />
            </div>
          ) : (
            <div className="flex flex-col gap-4 md:hidden">
              {workInfo?.map((item: any, index: number) => {
                if (item.name !== "Work Experience") {
                  return null;
                }

                const attributes = item?.attributes?.reduce(
                  (acc: any, attr: any) => {
                    acc[attr.name] = attr?.value;
                    return acc;
                  },
                  {}
                );
                const workDetailsPresent = Object.values(attributes).every(value => value === "");
                // console.log("===========>>>>", workDetailsPresent);
                // if( workDetailsPresent ) {
                //   console.log("inside if condition");
                //   setIsWorkDetailspresent(workDetailsPresent);
                // }
                // console.log("workDetailsPresent", workDetailsPresent);
                return (
                  <div
                    key={index}
                    className="bg-white shadow-md rounded-xl p-4 cursor-pointer hover:shadow-lg border border-gray-300"
                  >
                    <div className="flex justify-between items-start  gap-4">
                      <div>
                        <div className="font-nunitolabelText label label  text-label text-black">
                          {StaffListConstants.role}
                        </div>
                        <div className="text-black employeeId mb-3">
                          {attributes["roleName"]}
                        </div>
                      </div>

                      <div>
                        <div className="font-nunitolabelText label  text-label text-black">
                          {StaffListConstants.organizationName}
                        </div>
                        <div className="text-black employeeId mb-3">
                          {attributes["organizationName"]}
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-between items-start gap-4">
                      <div>
                        <div className="font-nunitolabelText label  text-label text-black">
                          {StaffListConstants.noOfYearsExperience}
                        </div>
                        <div className="text-black employeeId mb-3">
                          {attributes["numberOfYears"]}
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-end items-center ">
                      <div className="flex items-center gap-3 ">
                        <button
                          className="text-primary flex items-center"
                          onClick={(e) => {
                            handleEditWorkInformation(index);
                          }}
                        >
                          <EditIconForEditFLow height="24px" width="24px" />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div className="hidden lg:block">
        {" "}
        <div>
          {editModeForWorkDetails ? (
            <div>
              <PersonalInformationDynamic
                jsonObjForEdit={
                  addMoreWorkInfo ? jsonForEditData : [userDetail]
                }
                jsonobj={[jsonForEdit]} // Wrap the returned object in an array
                order={0}
                isEditMode={true}
                indexOfValueToBeModified={workDetailsIndex}
                setEditPayloadjson={setEditPayloadjson}
                addMoreWorkInfo={addMoreWorkInfo}
                addmoreWorkOrder={order}
                setJsonForEditFlow={setJsonForEdit}
                showWorkTableInEditFlow={showWorkTableInEditFlow}
                isSaveButtonCLicked={isSaveButtonCLicked}
                setIsSaveButtonClicked={setIsSaveButtonClicked}
                errors={errors}
                setErrors={setErrors}
                isWorkDetailsNullRef={isWorkDetailsNull}
              />
            </div>
          ) : (
            <div>
              <div>
                <table className="w-full my-8 border border-gray-300">
                  <thead className="bg-sideMenubackground h-[64px]">
                    <tr>
                      <th className={`pl-8 ${tableHeaderStyle} `}>
                        {StaffListConstants.role}
                      </th>
                      <th className={tableHeaderStyle}>
                        {StaffListConstants.organizationName}
                      </th>
                      <th className={tableHeaderStyle}>
                        {StaffListConstants.NumberOfYears}
                      </th>
                      <th className={tableHeaderStyle}>
                        {StaffListConstants.Action}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {workInfo?.map((item: any, index: number) => {
                      // Extracting values from attributes array
                      if (item.name !== "Work Experience") {
                        return null; // Skip rendering this item
                      }
                      const attributes = item?.attributes?.reduce(
                        (acc: any, attr: any) => {
                          // console.log("attr", attr, acc);
                          acc[attr.name] = attr?.value;
                          return acc;
                        },
                        {}
                      );
                      
                      const workDetailsPresent = Object.values(attributes).every(value => value === null);
                      // if( workDetailsPresent ) {
                      //   console.log("inside if condition");
                      //   setIsWorkDetailspresent(workDetailsPresent);
                      // }                  
                         return (
                        <tr className="border-b" key={index}>
                          {/* Role */}
                          <td className={tableDataStyle}>
                            {attributes["roleName"]}
                          </td>
                          {/* Organization Name */}
                          <td className={tableDataStyle}>
                            {attributes["organizationName"]}
                          </td>
                          {/* Number Of Years Experience */}
                          <td className={tableDataStyle}>
                            {attributes["numberOfYears"]}
                          </td>
                          {/* Action */}
                          <td
                          data-testid={`edit-work-${index}`}
                            className={tableDataStyle}
                            onClick={() => {
                              isEditMode ?
                              handleEditWorkInformation(index) :
                              handleEditWorkInformationInOnboardingFlow(index);
                            }}
                          >
                            <EditIconForEditFLow />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default WorkExperienceTable;
